// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__31J-u","paymentMethod":"Footer_paymentMethod__yPSrX","payment":"Footer_payment__srEw+","app":"Footer_app__EyOPP","image":"Footer_image__C57yJ"};